// import Image from "next/image";
import { Button, Form, Input, Select, Image, message } from "antd";
import { useEffect, useState } from 'react';
import gaTracker from "@/ga";
import { Icon } from "@iconify/react";
import Modal from '@/components-mobile/Modal';
import { countryPhoneCodes } from '@/constants/Phone';
import EligibleModal from "@/components/EligibleModal";
import { APICapInvitation, APIRefreshCapStatus, APIRequestSampleCreate } from '@/api';
import styles from './index.module.scss';


const FreeSamplePopup = ({ isVisible, title, sourceData, obtainRef, getCapInvite, reEligible, closePopup, addChange }) => {
  const [form] = Form.useForm();
  const [steps, setSteps] = useState(1);  // 0 tap   1  进来就看到    2  信息填写    3  申样后提示
  useEffect(() => {
    if (isVisible) {
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
      setSteps(1);
    } else {
      // 恢复页面滚动
      document.body.style.overflow = '';
    }
    // 在组件卸载时恢复页面滚动
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  const getSample = () => {
    // setPersonInfo(true);
    setSteps(obtainRef ? 2 : 0);
  };
  const clearInfo = () => {
    form.resetFields();
  };
  const handleSubmit = async () => {
    const values = await form.validateFields(); // 触发校验
    let submitValues = {
      ...values,
      phoneNum: `+${values.prefix}${' '}${values.phone}`
    };
    delete submitValues.prefix;
    delete submitValues.phone;
    console.log('~222', submitValues, values);
    APIRequestSampleCreate(JSON.stringify(submitValues)).then((resp) => {
      console.log("~resp", resp);
      // setPersonInfo(false);
      if (resp.data.result) {
        setSteps(3);
        form.resetFields();
      } else {
        message.info("Information submission failed, please try again.");
      }
      // closePopup();
    }).catch((error) => {
      closePopup();
      form.resetFields();
      console.log(error, "errorH5");
      message.info("Application failed, please try again");
    });

  };

  const prefixSelector = (
    <Form.Item name={"prefix"} noStyle>
      <Select
        style={{
          width: 70,
        }}
        // defaultValue={"86"}
        getPopupContainer={(triggerNode) => triggerNode.parentNode} // 解决被遮挡问题
      >
        {countryPhoneCodes.map((item, index) => (
          <Select.Option key={index} value={item.value}>
            +{item.value}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );

  return (
    isVisible && <div className={styles.overlay}
      onClick={(e) => {
        e.preventDefault();
        setSteps(1);
        closePopup();
      }}
      onTouchMove={(e) => {
        e.preventDefault(); // 阻止默认的触摸移动行为，防止页面滚动
      }}>
      <div className={`${styles.popup} ${isVisible ? styles['popup-enter'] : styles['popup-exit']
        }`} onClick={(e) => e.stopPropagation()} // 阻止事件冒泡，避免点击内容关闭 Popup
      >
        <div className={styles.header}>
          <div className={styles.headerLeft}>{steps !== 3 ? title : ''}</div>
          <div className={styles.headerRight} onClick={() => { setSteps(1); closePopup(); }}>
            <Icon icon='line-md:close' className={styles.headerRightIcon} />
          </div>
        </div>
        {steps !== 3 && <div className={styles.content} onTouchMove={(e) => {
          e.preventDefault(); // 阻止默认的触摸移动行为，防止页面滚动
        }}>
          <div className={styles.productBox}>
            <div className={`${styles.imageBox}`}>
              <img className={`${styles.image} `} src={sourceData?.alyImage} />
            </div>
            <div className={styles.title}>{sourceData?.title}</div>
          </div>
          <div className={styles.info}>
            {steps === 2 ?
              <div className={styles.infoTitle}>
                Fill in the information for offline sampling
              </div>
              : <div className={styles.infoTitle}>
                Join our Creator Affiliate Program to get offline samples!
              </div>}

            {steps === 0 ? <div>
              <ol>
                <li className={styles.infoText} style={{ marginTop: '17px', marginLeft: '15px' }}>Ready to join our Creator Affiliate Program? After joining, you’ll enjoy:
                  <ul>
                    <li className={styles.infoText} >Our <span className={styles.infoTextDiff}>Highest Commissions</span> on every product (ranging from 12%-30%)</li>
                    <li><span className={styles.infoTextDiff}>Offline samples</span></li>
                    <li><span className={styles.infoTextDiff}>Exclusive Extra View Boost</span></li>
                    <li className={styles.infoText}>Personalized <span className={styles.infoTextDiff}>1v1 support</span></li>
                    <li className={styles.infoText}>TikTok Flash Sales</li>
                  </ul>
                </li>
                <li className={styles.infoText} style={{ marginTop: '10px', marginLeft: '15px' }}>Click the “<span className={styles.infoTextDiff}>Obtain Eligibility</span>” button below and we'll send you a <span className={styles.infoTextDiff}>partner link</span> and more partner details from our affiliate account <span className={styles.infoTextDiff}>Uango</span> to your TikTok. Simply check the link we sent and <span className={styles.infoTextDiff}>accept the request </span>! </li>
              </ol>
            </div> : (
              steps === 2 ?
                <Form
                  form={form}
                  autoComplete={"off"}
                  layout={"vertical"}
                  initialValues={{ prefix: '86' }}
                  style={{ marginTop: '12px', marginBottom: '42px' }}
                >
                  <Form.Item
                    label={"Address"}
                    name={"address"}
                    rules={[
                      {
                        required: true,
                        message: 'Please input your address!',
                      },
                    ]}
                  >
                    <Input maxLength={500} placeholder={"An available address to receive the sample"} />
                  </Form.Item>
                  <Form.Item
                    label={"Zip Code"}
                    name={"zipCode"}
                    rules={[
                      {
                        required: true,
                        message: 'Please input your Zip Code!',
                      },
                    ]}
                  >
                    <Input maxLength={20} placeholder={"Zip code"} />
                  </Form.Item>
                  <Form.Item
                    label={"E- Mail"}
                    name={"email"}
                    rules={[
                      {
                        required: true,
                        message: 'Please input your E- Mail!',
                      },
                      { pattern: /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/, message: "E-Mail format error" }
                    ]}
                  >
                    <Input maxLength={300} placeholder={"Your E-Mail address"} />
                  </Form.Item>
                  <Form.Item
                    label={"Name"}
                    name={"name"}
                    rules={[
                      {
                        required: true,
                        message: 'Please input your name!',
                      },
                    ]}
                  >
                    <Input maxLength={50} placeholder={"Your name"} />
                  </Form.Item>
                  <Form.Item
                    // form={form}
                    label={"Phone"}
                    name={"phone"}
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number!',
                      },
                      { pattern: /^(\+\d{1,3}( )?)?((\$\d{1,4}\$)|\d{1,4})[- .]?\d{1,4}[- .]?\d{1,9}$/, message: "Phone number format error" }

                    ]}
                  >
                    <Input
                      maxLength={20}
                      addonBefore={prefixSelector}
                      placeholder={"The contact phone number"} />
                  </Form.Item>
                  <Form.Item
                    label={"Product Note"}
                    name={"productNote"}
                  >
                    <Input.TextArea count={{
                      show: true,
                      max: 500,
                    }}
                      maxLength={500}
                      placeholder={"Please enter the size, color and other information. Leave blank to automatically select the default option."} />
                  </Form.Item>
                  {/* </div> */}
                </Form>
                : <div style={{ paddingBottom: '20px' }}>
                  <ol>
                    <li className={styles.infoText} style={{ marginTop: '17px', marginLeft: '15px' }}>Click <span className={`${styles.infoTextDiff} underline `} onClick={(e) => { addChange(e); }}>Add to Showcase</span> to add the product to your showcase</li>
                    <li className={styles.infoText} style={{ marginLeft: '15px' }}>Check the TikTok Product Card Info to see if there is a <span className={styles.infoTextDiff}>Get Free Sample</span> button</li>
                    <li className={styles.infoText} style={{ marginLeft: '15px' }}>If you see the Get Free Sample button on TikTok, <span className={styles.infoTextDiff}>follow the process below</span> to request a sample</li>
                    <li className={styles.infoText} style={{ marginLeft: '15px' }}>If you don't see the Get Free Sample button on TikTok, click the <span className={styles.infoTextDiff}>Request Sample Offline</span> button below to send an offline request sample</li>
                  </ol>
                  {/* <AntdImage className={"object-cover"} src={"/images/product/get-free-sample-icon.svg "} alt='Preview'></AntdImage> */}
                  {/* /images/product/get-free-sample-icon.svg */}
                  <Image.PreviewGroup
                    items={[
                      "/images/product/Group 645.svg",
                      "/images/product/Group 646.svg",
                      "/images/product/Group 647.svg",
                      "/images/product/Group 649.svg",
                      "/images/product/Group 650.svg",
                      "/images/product/Group 651.svg",
                    ]}
                  >
                    <Image
                      className={"object-cover"}
                      src={"/images/product/free-sample-h5.png "}
                    />
                  </Image.PreviewGroup>
                </div>
            )
            }
          </div>
        </div>}

        {steps !== 3 && <div className={styles.footer}>
          {steps === 0
            ? <div className={styles.footerBox}>
              <div className={styles.submit} onClick={getCapInvite}>Obtain Eligibility</div>
              <div className={styles.cancel} onClick={reEligible}>I'm already eligible</div>
            </div>
            : (steps === 2
              ? <div className={styles.footerBox}>
                <div className={styles.submit} onClick={handleSubmit}>Submit</div>
                <div className={styles.cancel} onClick={clearInfo}>Clear All</div>
              </div>
              : <div className={styles.request} onClick={getSample}>Request Sample Offline</div>)}

        </div>}
        {steps === 3 && <div className={styles.sampleSuccess}>
          <Icon icon='mdi:checkbox-marked-circle-auto-outline' className={styles.topIcon} />
          <div className={styles.text1}>If your sample request is approved and sent out by the merchant, we will notify you within a week via email /anyStarr US/ Befriends SSG US/ Uango and shop account tagged with anyStarr. We'll also include the courier number where the sample was sent so you can check it out at any time!</div>
          <ul className={styles.text2Box}>
            <li className={styles.text2}>PLEASE NOTE Your sample request will be forwarded to the merchant and reviewed by the merchant based on your online fulfillment performance and gmv sales. anyStarr cannot guarantee that your sample request will be reviewed and approved. You can increase your chances of approval by posting more videos of the samples you have received and improving your profile and e-commerce information settings. </li>
            <li className={styles.text2}>Posting a sample-related video within 1-2 weeks of receiving a sample will greatly increase the probability of receiving your next offline sample.</li>
          </ul>
        </div>}
      </div>
    </div >
  );
};
export default FreeSamplePopup;